import { useRouter } from 'next/router'
import { useDispatch, useSelector } from 'react-redux'
import { useEffect } from 'react'
import { setCurrentBrand, useGetAllBrandsQuery, useGetBrandQuery } from '@/redux/slices/brandSlice'

const useBrandSelect = () => {
    const dispatch = useDispatch()
    const { query, isReady } = useRouter()
    const {
        data: selectedBrand,
        isFetching: isFetchingSingleBrand,
        isLoading: isLoadingSingleBrand,
    } = useGetBrandQuery(
        {
            brand_id: query?.brandId,
        },
        { skip: !isReady || !query?.brandId },
    )

    const { data: brands, isFetching: isFetchingAllBrands } = useGetAllBrandsQuery(
        {},
        { skip: !isReady || isLoadingSingleBrand || selectedBrand },
    )

    const currentBrand = useSelector((state) => state.brandSlice.currentBrand)

    // Initialize the currentBrand
    useEffect(() => {
        if (isFetchingSingleBrand || isLoadingSingleBrand || !isReady || currentBrand) {
            return
        }

        if (selectedBrand) {
            dispatch(setCurrentBrand(selectedBrand))
            return
        }

        if (isFetchingAllBrands) {
            return
        }

        const availableBrands = brands?.results || brands || []

        if (availableBrands.length > 0) {
            const firstActiveBrand = availableBrands?.find((b) => b.status === 'active')

            dispatch(setCurrentBrand(firstActiveBrand ? firstActiveBrand : availableBrands[0]))
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [brands, query, isFetchingAllBrands, isFetchingSingleBrand, currentBrand, isReady])

    return {
        currentBrand,
    }
}

export default useBrandSelect
